import { TranslationKey } from '../models';
import type { ILabelMapper } from './ILabelMapper';
import { Localization } from './Localization';

interface ILabelMapperTransforms {
  [key: string]: string;
  _default: string;
}

export class GenderLabelMapperInternal implements ILabelMapper {
  getLocalizationKey(label: string): JSX.Element | string {
    const transforms: ILabelMapperTransforms = {
      Man: TranslationKey.genderLabelMan,
      Other: TranslationKey.genderLabelOther,
      Woman: TranslationKey.genderLabelWoman,
      _default: label,
    };

    const key = (label in transforms ? transforms[label] : transforms._default) as TranslationKey;

    return (
      <Localization
        defaultMessage={key}
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- because we need use as is
        id={key ?? ''}
      />
    );
  }
}

export const GenderLabelMapper = new GenderLabelMapperInternal();
